import * as React from 'react';
import { TableMapper } from '../../shared';
export var TableBodyRowMapper = function () { return (React.createElement(TableMapper, { rampName: "BodyRowCellBase" })); };
